import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { Column } from '@ant-design/plots';
import { Button, Row, Col, Form, setParamsFilter, ProTableOt as ProTable_ot, useProTableOt, DemoProTableOt, message, Modal } from "../../../../../templates/my-app/src/components/ui/ot"
import CompetencyModal from "./competency_modal";
import { useSmartTaskSchedulingTaskCategory } from "../pmis/controller/smart_task_scheduling_task_category_controller";
import { useTranslation } from 'react-i18next';
import CategoryModal from './smart_task_scheduling_task_category_modal';



const SmartTaskSchedulingTaskCategoryTable = ({
    edit = true,
    api = `/pmis/smart_task_scheduling/task_category`,
    onCheckTesk = () => { },
    modalFlag = 0,
    keyPrefix = "pmis.smartTaskSchedulingTaskCategory",
    onSelectChange = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const columns = [
        {
            title: t('index'),
            sorter: false,
            dataIndex: 'key',
            key: 'key',
            width: "10rem",
            // copyable: true,
        },
        {
            title: t('category_name'),
            sorter: false,
            dataIndex: 'category_name',
            key: 'category_name',
            width: "10rem",
            // copyable: true,
        },
        {
            title: t('action'),
            dataIndex: '操作',
            sorter: false,
            key: '操作',
            fixed: "right",
            disabled: true,
            width: "4rem",
            render: (_, record) => {
                return (
                    <Row gutter={[8, 8]}>
                        <Col span={12}>
                            <Button
                                variant={"table_row_clean_button"}
                                style={{
                                    color: '#2BC17B'
                                }}
                                onClick={() => {
                                    handleEditRow(record)
                                }}
                            >
                                {t('edit')}
                            </Button>
                        </Col>
                        <Col span={12}>
                            <Button
                                variant={"table_row_clean_button"}
                                style={{
                                    color: "#ff0000"
                                }}
                                onClick={() => handleDeleteRow(record?.category_id)}
                            >
                                {t('delete')}
                            </Button>
                        </Col>
                    </Row>
                )
            }
        }
    ]
    const actionRef = useRef(null)
    const [checkTask, setCheckTask] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectedRowsInfo)
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectedRowsKeys)
    const [extra_columns, set_extra_columns] = useState([]);
    const [categoryClassification, setCategoryClassification] = useState(null)
    const reloadTable = () => {
        actionRef.current.reload()
        setCheckTask([])
    }
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.task_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.task_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.task_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.task_id)
                selectRow = selectRow.filter(row => row.task_id !== record.task_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("get")

    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)

        form.resetFields()
        form.setFieldsValue({
            ...record,
        })
    }
    const handleDeleteRow = (id) => {
        /* 刪除單／多筆資料 */
        let data = []
        /* 將PK做成陣列 */
        if (id) {
            /* 當單筆刪除時會帶入id */
            data = [{
                category_id: id
            }]
            /* 放入欲刪除的陣列 */
        }

        else {
            data = selectedRowsInfo.map((val) => {
                /* 將已勾選的資料遍歷 */
                return {
                    category_id: val?.category_id
                }
                /* 取出pk放回陣列 */
            })
        }
        if (data.length > 0) {
            /* 防呆未勾選任何資料 */
            Modal.confirm({
                /* 一次性使用Modal且有確定與取消的按鈕 */
                content: '確定要刪除嗎？',
                /* modal內容 */
                onOk: () => {
                    deleteSmartTaskSchedulingTaskCategoryData(data)
                    /* 當按下確定後觸發刪除資料 */
                },
                okText: '確定',
                /* 確定的按鈕顯示的文字 */
                cancelText: '取消',
                /* 取消的按鈕顯示的文字 */
                contentStyle: {
                    zindex: 99,
                }
            })
        }
        else {
            message.info("請選擇項目")
            /* 一次性呈現上方提示字 */
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postSmartTaskSchedulingTaskCategoryData([values])
        }
        else if (axiosMode === "patch") {
            patchSmartTaskSchedulingTaskCategoryData([values])
        }
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                // actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                // actionRef.current.reloadAndRest();
            }
            // setModalLoading(false)
            // setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }

    const { 
        getSmartTaskSchedulingTaskCategoryData,
        postSmartTaskSchedulingTaskCategoryData,
        patchSmartTaskSchedulingTaskCategoryData,
        deleteSmartTaskSchedulingTaskCategoryData,
    } = useSmartTaskSchedulingTaskCategory({
        onFinish,
        onBefore,
    });
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    useEffect(() => {
        onCheckTesk(checkTask)
    }, [checkTask])

    useEffect(() => {
        checkAll()
    }, [])
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])


    return (
        <Row gutter={[8, 8]}>
            <CategoryModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
            />
            <Col span={24}>
                <ProTable_ot
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    headerTitle={<></>}
                    rowKey={'category_id'}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                        };
                        let order = setOrders(sort)
                        newParams = {
                            ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword,
                            custom_filter_key: custom_filter_key
                        }
                        newParams = {
                            ...newParams,
                            category_classification_id: categoryClassification
                        }
                        newParams = setParamsFilter({
                            ...newParams,
                        });
                        return getSmartTaskSchedulingTaskCategoryData({
                            ...newParams
                        })
                    }}
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={false}
                    scroll={{
                        x: "100vw"
                    }}
                    toolBarRender={() => [
                        <Button
                            type={'primary'}
                            onClick={() => handleAddRow()}
                        >
                            {t('post_category')}
                        </Button>,
                        <Button
                            variant={"batchDelete"}
                            onClick={() => handleDeleteRow()}
                        >
                            {t('delete_multiple')}
                        </Button>,
                    ]}
                />
            </Col>
        </Row >
    )
}
const SmartTaskSchedulingTaskCategory = ({
    propsForm,
    onFormFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    ...props
}) => {
    const [form_] = Form.useForm();
    const form = propsForm || form_
    const getFormValues = () => {
        let values = {}
        values = form.getFieldsValue()
        return values
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onSelectChange = (selectedRowsInfo) => {
        form.setFieldsValue({ selectedRowsInfo: selectedRowsInfo })
    }
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={form}
                    onValuesChange={() => { }}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                name={"selectedRowsInfo"}
                                hidden={true}
                            >
                            </Form.Item>
                            <SmartTaskSchedulingTaskCategoryTable
                                defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                                defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                                onSelectChange={onSelectChange}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export { SmartTaskSchedulingTaskCategoryTable }
export default SmartTaskSchedulingTaskCategory;









// const SmartTaskSchedulingTaskCategory_test = () => {
//     const actionRef = useRef();
//     const [spinLoading, setSpinLoading] = useState(true);

//     const columns = [
//         {
//             title: "分類名稱",
//             dataIndex: "category_name",
//             key: "category_name",
//         },
//         {
//             title: "操作",
//             valueType: "option",
//             key: "option",
//             fixed: "right",
//             sorter: false,
//             disabled: true,
//             render: (text, record, _index) => {
//                 return (
//                     <Row gutter={[8,8]}>
//                         <Col>
//                             <Button
//                                 type="link"
//                                 style={{
//                                     color: "#2BC17B",
//                                 }}
//                                 onClick={() => {
//                                     // handleEditRow(record)
//                                     set_table_is_editing(true)
//                                     set_competency_modal_form_data(record)
//                                 }}
//                             >
//                                 修改
//                             </Button>
//                         </Col>
//                         <Col>
//                             <Button 
//                                 type="link" 
//                                 danger
//                                 onClick={() => {
//                                     handleDeleteRows(record)
//                                 }}
//                             >
//                                 刪除
//                             </Button>
//                         </Col>
//                     </Row>
//                 );
//             },
//         },
//     ];
//     const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//     const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
//     const [extra_columns, set_extra_columns] = useState([]);
//     const rowSelection = {
//         //不一定都是對id
//         onSelectAll: (selected, selectedRows, changeRows) => {
//             console.log({
//                 selected,
//                 selectedRows,
//                 changeRows,
//             });
//             let select_temp = [];
//             let selectRow = [];
//             select_temp = [...selectedRowKeys];
//             selectRow = [...selectedRowsInfo];

//             if (selected) {
//                 changeRows.map((value, key) => {
//                     select_temp.push(value.news_id);
//                     selectRow.push(value);
//                 });
//             } else {
//                 changeRows.map((value, key) => {
//                     const index = select_temp.indexOf(value.news_id);
//                     select_temp.splice(index, 1);
//                     selectRow.splice(index, 1);
//                 });
//             }
//             setSelectedRowKeys(select_temp);
//             setSelectedRowsInfo(selectRow);
//         },
//         onSelect: (record, selected, selectedRows, nativeEvent) => {
//             let select_temp = [];
//             let selectRow = [];
//             select_temp = [...selectedRowKeys];
//             selectRow = [...selectedRowsInfo];

//             if (selected) {
//                 select_temp.push(record.news_id);
//                 selectRow.push(record);
//             } else {
//                 select_temp = select_temp.filter(
//                     (key) => key !== record.news_id
//                 );
//                 selectRow = selectRow.filter(
//                     (row) => row.news_id !== record.news_id
//                 );
//             }
//             setSelectedRowKeys(select_temp);
//             setSelectedRowsInfo(selectRow);
//         },
//         getCheckboxProps: (record) => ({
//             // disabled: record.pass === null,
//         }),
//     };
//     const setParamsFilter = (obj) => {
//         return Object.entries(obj).reduce(
//             (all, [key, value]) =>
//                 value === "" ? { ...all } : { ...all, [key]: value },
//             {}
//         );
//     };
//     const [form] = Form.useForm();
//     const [axiosMode, setAxiosMode] = useState("get")
//     const [modalOpen, setModalOpen] = useState(false)
//     const [modalLoading, setModalLoading] = useState(false)
//     const [table_is_editing, set_table_is_editing] = useState(false)
//     const [competency_modal_form_data, set_competency_modal_form_data] = useState([])
//     const [delete_rows, set_delete_rows] = useState([])
//     const [delete_modal_open, set_delete_modal_open] = useState(false)
//     const handleDeleteRows = (data) => {
//         set_delete_rows([data])
//         set_delete_modal_open(true)
//     }
//     const onDeleteFinish = () => {
//         deleteSmartTaskSchedulingTaskCategoryData(delete_rows)
//     }

//     const onFinish = ({ axiosMode, status, values }) => {
//         if (status === "success") {
//             if (axiosMode === "post") {
//                 message.success("新增成功")
//                 actionRef.current.reloadAndRest();
//             }
//             else if (axiosMode === "patch") {
//                 message.success("修改成功")
//                 actionRef.current.reloadAndRest();
//             }
//             else if (axiosMode === "delete") {
//                 message.success("刪除成功")
//                 actionRef.current.reloadAndRest();
//                 setSelectedRowKeys([])
//                 setSelectedRowsInfo([])
//             }
//             setModalLoading(false)
//             setModalOpen(false)
//             set_delete_modal_open(false)
//             setSpinLoading(false)
//         }
//         else if (status === "failure") {
//             if (axiosMode === "post") {
//                 message.error("新增失敗")
//                 actionRef.current.reloadAndRest();
//             }
//             else if (axiosMode === "patch") {
//                 message.error("修改失敗")
//                 actionRef.current.reloadAndRest();
//             }
//             else if (axiosMode === "delete") {
//                 message.error("刪除失敗")
//                 actionRef.current.reloadAndRest();
//             }
//             setModalLoading(false)
//             setModalOpen(false)
//             set_delete_modal_open(false)
//             setSpinLoading(false)
//         }
//     };
//     const onBefore = ({ axiosMode, status, values }) => {
//         setModalLoading(true)
//     };
//     const {
//         check,
//         setCheck,
//         checkAll,
//         setOrders,
//         custom_filter_key,
//         transferColumnAntdToShadcn,
//         transferSortAntdToShadcn,
//     } = useProTableOt({
//         columns,
//     });

//     const onFormFinish = (values) => {
//         let body = {}
//         for (const key in values) {
//             if (values[key] !== undefined) {
//                 body[key] = values[key];
//             }
//         }
//         if (axiosMode === "post") {
//             postSmartTaskSchedulingTaskCategoryData([body])
//         }
//         else if (axiosMode === "patch") {
//             patchSmartTaskSchedulingTaskCategoryData([values])
//         }
//     }

//     const { 
//         getSmartTaskSchedulingTaskCategoryData,
//         postSmartTaskSchedulingTaskCategoryData,
//         patchSmartTaskSchedulingTaskCategoryData,
//         deleteSmartTaskSchedulingTaskCategoryData,
//     } = useSmartTaskSchedulingTaskCategory({
//         onFinish,
//         onBefore,
//     });


//     useEffect(() => {
//     }, [])
//     useEffect(() => {
//         set_delete_rows(selectedRowsInfo)
//     }, [selectedRowsInfo])



//     return (<>
//         <Spin tip={"載入中"} spinning={spinLoading}>
//             <Row>
//                 <Col>
//                     <CompetencyModal
//                         open={modalOpen}
//                         axiosMode={axiosMode}
//                         propsSetOpen={setModalOpen}
//                         propsForm={form}
//                         propsLoading={modalLoading}
//                         propsSetLoading={setModalLoading}
//                         onFinish={onFormFinish}
//                         changeAxiosMode={setAxiosMode}
//                         is_editing={table_is_editing}
//                         set_is_editing={(data) => {
//                             set_table_is_editing(data)
//                             set_competency_modal_form_data([])
//                         }}
//                         modal_form_data={competency_modal_form_data}
//                         set_competent_modal_open={setModalOpen}
//                         props_delete_open={delete_modal_open}
//                         onDeleteFinish={() => {
//                             onDeleteFinish()
//                         }}
//                     />
//                 </Col>
//                 <Col span={24}>
//                     <ProTableOt
//                         actionRef={actionRef}
//                         columns={columns}
//                         check={check}
//                         setCheck={setCheck}
//                         headerTitle={<>職能資料設定</>}
//                         rowKey={"category_id"}
//                         request={async (params = {}, sort, filter) => {
//                             setAxiosMode("get")
//                             let newParams = {};
//                             let order = setOrders(sort);
//                             newParams = {
//                                 ...params, //只有這個範例要有，其他請看你的後端要什麼資料
//                                 ...newParams,
//                                 order,
//                                 size: params.pageSize,
//                                 cur_page: params.current,
//                                 custom_filter_value: params.keyword ?? "",
//                                 custom_filter_key: custom_filter_key,
//                             };
//                             newParams = setParamsFilter({
//                                 ...newParams,
//                             });
//                             // setPageSize(params?.pageSize ?? 20)

//                             return getSmartTaskSchedulingTaskCategoryData({
//                                 ...newParams,
//                             });
//                         }}
//                         toolBarRender={() => {
//                             return [
//                                 <Button
//                                     onClick={() => {
//                                         actionRef.current.reload();
//                                     }}
//                                 >
//                                     重整按鈕
//                                 </Button>,
//                             ];
//                         }}
//                         rowSelection={{
//                             type: "checkbox",
//                             selectedRowKeys: selectedRowKeys,
//                             ...rowSelection,
//                         }}
//                         extra_columns={extra_columns}
//                         set_extra_columns={set_extra_columns}
//                         manage_columns={true}
//                     />
//                 </Col>
//             </Row>
//         </Spin>
//     </>)
// }

// export default SmartTaskSchedulingTaskCategory;